// extracted by mini-css-extract-plugin
module.exports = {"root":"bread_crumbs_root__2a60h","link_item":"bread_crumbs_link_item__XWWHB"};